import { render, staticRenderFns } from "./12-power1.vue?vue&type=template&id=56f407a8&scoped=true&"
import script from "./12-power1.vue?vue&type=script&lang=js&"
export * from "./12-power1.vue?vue&type=script&lang=js&"
import style0 from "./12-power1.vue?vue&type=style&index=0&id=56f407a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f407a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f407a8')) {
      api.createRecord('56f407a8', component.options)
    } else {
      api.reload('56f407a8', component.options)
    }
    module.hot.accept("./12-power1.vue?vue&type=template&id=56f407a8&scoped=true&", function () {
      api.rerender('56f407a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/12-power1.vue"
export default component.exports